document.addEventListener('DOMContentLoaded', function () {
  const popupOverlay = document.getElementById('boxie-popup');
  const popupImage = document.getElementById('popup-image');
  const popupClose = document.querySelector('.boxie-popup-close');

  if (!popupOverlay || !popupImage) return;

  // Fallback popup images used only when the customizer image is not set.
  const fallback = {
    lil: 'https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Pop_Up_1_1.jpg?v=1762587363',
    big: 'https://cdn.shopify.com/s/files/1/0762/7862/8674/files/Pop_Up_4.jpg?v=1762431181',
  };

  function showPopup(imageSrc) {
    if (!imageSrc) return;
    popupImage.src = imageSrc;
    popupOverlay.style.display = 'flex';
  }

  // Delegated click listener — each box opens its own popup image.
  document.addEventListener('click', function (e) {
    const targetBox =
      e.target.closest('.ct-birth-boxie-lil-boxie') || e.target.closest('.ct-birth-boxie-boxie');
    if (!targetBox) return;

    const isLil = targetBox.classList.contains('ct-birth-boxie-lil-boxie');
    const imageSrc = targetBox.dataset.popupImg || (isLil ? fallback.lil : fallback.big);
    showPopup(imageSrc);
  });

  // Close popup
  if (popupClose) {
    popupClose.addEventListener('click', () => {
      popupOverlay.style.display = 'none';
    });
  }

  popupOverlay.addEventListener('click', (e) => {
    if (e.target === popupOverlay) {
      popupOverlay.style.display = 'none';
    }
  });
});
